<!--
 * 严肃声明：
 * 开源版本请务必保留此注释头信息，若删除我方将保留所有法律责任追究！
 * 本系统已申请软件著作权，受国家版权局知识产权以及国家计算机软件著作权保护！
 * 可正常分享和学习源码，不得用于违法犯罪活动，违者必究！
 * Copyright (c) 2020 陈尼克 all rights reserved.
 * 版权所有，侵权必究！
 *
-->

<template>
  <div class="user-box">
    <s-header :name="'我的'"></s-header>
    <div>
      <div class="user-info">
        <div class="info">
          <img :src="user&&user.head_image?user.head_image:'https://s.yezgea02.com/1604040746310/aaaddd.png'"/>
          <div class="user-desc" @click="login" v-if="JSON.stringify(user)=='{}'">请先登录</div>
          <div class="user-desc" style="display: flex;flex-direction: column" v-else>
            <div style="display: flex">
              <span>{{ user.nickname || user.sername || user.username }}</span>
              <button style="margin-left: 8px" class="copy-button" @click="clipboardFun( user.nickname || user.sername || user.username )">复制
              </button>
            </div>

            <div style="display: flex">
              <span>ID：</span>
              <span class="overTxt">{{ user.id }}</span>
              <button class="copy-button" @click="clipboardFun( user.id )">复制</button>
            </div>
          </div>
        </div>
      </div>
      <div class="showBox">
        <div class="showCon">
          <p class="title">
            <span class="iconfont icon-huiyuan"></span>
            <span style="margin-left: 10px">欢迎您的浏览</span>
          </p>
          <div class="orderList">
            <li class="loginBtn" @click="login" v-if="JSON.stringify(user)=='{}'">
              <span class="iconfont icon-mima" style="color: red"></span>
              <span style="line-height: 22px">登录后查看</span>
            </li>
            <ul class="orderCon" v-else>
              <li v-for="(val, index) in cateList" :key="index" class="van-hairline--bottom" @click="gotoList(val)">
                <span class="iconfont" :class="val.icon"></span>
                <p>{{ val.title }}</p>
                <span class="orderCount">{{ val.num }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="lastContent">
      <ul class="user-list">
        <li v-for="(val, index) in list" :key="index" class="van-hairline--bottom" @click="goTo(val)">
          <p>
            <span :class="val.icon" class="iconfont"></span>
          </p>
          <p style="margin-left: 10px">{{ val.title }}</p>
        </li>
      </ul>
    </div>
    <van-dialog v-model:show="show" title="添加微信好友">
      <div style="text-align: center">
        <img width="200" src="@/assets/wx.jpg" />
      </div>
    </van-dialog>
    <nav-bar></nav-bar>
  </div>
</template>

<script>
  import {reactive, onMounted, toRefs, ref} from 'vue'
import navBar from '@/components/NavBar'
import sHeader from '@/components/SimpleHeader'
import {getMemberInfo, wechatLogin} from '@/service/user'
import {useRouter} from 'vue-router'
import {getLocal, setLocal} from "@/common/js/utils";
import Clipboard from 'clipboard';
import {showFailToast, showSuccessToast} from "vant";

export default {
  components: {
    navBar,
    sHeader
  },
  setup() {
    const show = ref(false)
    const router = useRouter()
    const state = reactive({
      // 订单分类
      cateList: [
        {
          title: '待付款',
          type: 0,
          icon: 'icon-dingdandaifukuan'
        },
        {
          title: '待发货',
          type: 1,
          icon: 'icon-daifahuo'
        },
        {
          title: '待收货',
          type: 2,
          icon: 'icon-daishouhuo'
        },
        {
          title: '已完成',
          type: 3,
          icon: 'icon-pingjia'
        },
        {
          title: '退款/售后',
          icon: 'icon-tuikuan'
        }
      ],
      // 下方列表
      list: [
        {
          title: '地址薄',
          icon: 'icon-dizhiguanli',
          routeUrl: '/good/site'
        },
        {
          title: '兑换卡券',
          icon: 'icon-lingquanzhongxin'
        },
        {
          title: '联系客服',
          icon: 'icon-kefu'
        },
        {
          title: '食品溯源',
          icon: 'icon-shipinsuyuanWEB_shipinshengchanqiyeruzhu',
          routeUrl: '/trace'
        },
        {
          title: '二维码',
          icon: 'icon-erweima'
        },
        {
          title: '我的收藏',
          icon: 'icon-shoucang',
          routeUrl: '/followList'
        },
        {
          title: '分享',
          icon: 'icon-fenxiang_2'
        },
        {
          // title: '意见反馈',
          title: '设置',
          icon: 'icon-shezhi',
          routeUrl: '/setUp'
        }
      ],
      user: {},
      loading: true,
      code: null
    })

    onMounted(async () => {
      //判断是否有code
      if (getUrlCode().code) {
        state.code = getUrlCode().code;
        const {data} = await wechatLogin({code: state.code})
        setLocal('token', data.access_token)
        window.location.href = '/'
      }
      const token = getLocal('token')
      if (token) {
        const {data} = await getMemberInfo()
        const orderSynthesizeNumArr = [];
        for (let item in data.order_synthesize_num) {
          orderSynthesizeNumArr.push(data.order_synthesize_num[item])
        }
        state.cateList.forEach((item, num) => {
          item.num = orderSynthesizeNumArr[num]
        })
        state.user = data
        state.loading = false
      }
    })

    const clipboardFun = (val) => {
      let clipboard = new Clipboard('.copy-button', {
        text: () => val
      });
      clipboard.on('success', () => {
        showSuccessToast('复制成功！')
      });
      clipboard.on('error', () => {
        showFailToast('复制失败~')
      });
    }


    // 获取微信授权
    const login = () => {
      //如果是微信
      if (/(MicroMessenger)/i.test(navigator.userAgent)) {
        let appid = "wxb1079e08e023348b"; //微信APPid
        let local = "https://meshop.vdvq.com/";
        //打开地址进行授权
        window.location.href =
            "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
            appid +
            "&redirect_uri=" +
            encodeURIComponent(local) +
            "&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
      } else {
        router.push({path: '/login'})
      }
    }
    // 获取code
    const getUrlCode = () => {
      // 截取url中的code方法
      var url = location.search;
      var theRequest = new Object();
      if (url.indexOf("?") != -1) {
        var str = url.substr(1);
        var strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
        }
      }
      return theRequest;
    }
    const goBack = () => {
      router.go(-1)
    }

    const goTo = (r, query) => {
      if(r.title === '联系客服' || r.title === '二维码'){
        show.value = true
      } else {
        router.push({path: r.routeUrl, query: query || {}})
      }
    }

    function gotoList(val) {
      router.push({path: '/orderList', query: {type: val.type}})
    }

    return {
      ...toRefs(state),
      login,
      gotoList,
      getUrlCode,
      goBack,
      goTo,
      show,
      clipboardFun
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/common/style/mixin';

:deep(.van-popup--center){
  width: 80%;
}
.overTxt{
  display: inline-block;
  width: 60%;
  margin-right: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.user-box {
  .user-header {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10000;
    .fj();
    .wh(100%, 44px);
    line-height: 44px;
    padding: 0 10px;
    .boxSizing();
    color: #252525;
    background: #fff;

    .user-name {
      font-size: 14px;
    }
  }

  .user-info {
    background: #F9F9F9;

    .info {
      position: relative;
      display: flex;
      width: 100%;
      align-items: center;
      padding: 25px 20px;
      .boxSizing();

      img {
        .wh(60px, 60px);
        border-radius: 50%;
        margin-top: 4px;
      }

      .user-desc {
        font-weight: bold;
        margin-left: 10px;
        font-size: 18px;
        color: #303133;

        span {
          font-size: 14px;
          padding: 2px 0;
        }
      }

      .account-setting {
        position: absolute;
        top: 10px;
        right: 20px;
        font-size: 13px;
        color: #fff;

        .van-icon-setting-o {
          font-size: 16px;
          vertical-align: -3px;
          margin-right: 4px;
        }
      }
    }
  }

  .showBox {
    padding: 0 16px;
    background: #F9F9F9;

    .showCon {
      padding-bottom: 2px;
      border-radius: 20px;
      background: #8C211B;

      .title {
        color: #f7d680;
        font-size: 16px;
        margin: 0 0 0 20px;
        padding-top: 10px;
      }

      .img {
        position: absolute;
        right: 1px;
        top: 13px;
        height: 120px;
      }

      .orderList {
        margin: 4px;
        background: #fff;
        border-radius: 12px;
        padding: 10px 0 10px;

        .orderCon {
          padding: 10px 10px 0;
          background: #fff;
          display: flex;
          text-align: center;
          justify-content: space-between;
          align-items: center;

          .iconfont {
            color: #333;
            font-weight: bold;
            display: inline-block;
            padding: 10px;
            background: #E0AFAA;
            border-radius: 50%;
          }

          li {
            position: relative;
            width: 25%;

            .orderCount {
              position: absolute;
              top: -6px;
              right: 0px;
              width: 20px;
              height: 20px;
              background: #333;
              color: #fff;
              border-radius: 50%;
              text-align: center;
              line-height: 20px;
            }
          }
        }
      }
    }
  }

  .loginBtn {
    height: 100px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .lastContent {
    padding: 0 16px 60px;
    background: #F9F9F9;

    .user-list {
      display: flex;
      flex-wrap: wrap;
      margin-top: 20px;
      padding: 20px 20px;
      background: #fff;
      border-radius: 20px;


      li {
        width: 25%;
        text-align: center;
        font-size: 14px;

        .iconfont {
          color: #333;
          font-weight: bold;
        }
      }
    }
  }
}
</style>
